import { render } from "./AdminEstateUpdate.vue?vue&type=template&id=a4045468&scoped=true&ts=true&lang=pug"
import script from "./AdminEstateUpdate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminEstateUpdate.vue?vue&type=script&lang=ts&setup=true"

import "./AdminEstateUpdate.vue?vue&type=style&index=0&id=a4045468&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4045468"]])

export default __exports__